import React from 'react';
import styles from './index.module.scss';

const FirstColCellContent = ({ date: _date, children }) => {
  const date = _date.format('D');
  const day = _date.format('dd');
  const month = _date.format('MMM');

  return (
    <>
      {children}
      <span className={styles.date}>
        {date} <br /> {day}
      </span>

      <span className={styles.month}>{month}</span>
    </>
  );
};

export default FirstColCellContent;
